export function helpTabs() {
	const sections = document.querySelectorAll(".help-content");

	if (!sections.length) return;

	sections.forEach((section) => {
		const tabsContainer = section.querySelector(".help-content__tabs");
		const rightColumn = section.querySelector(".help-content__right");

		if (!tabsContainer) return;

		const tabs = Array.from(
			tabsContainer.querySelectorAll(":scope > .help-content__tab")
		);
		const contents = rightColumn
			? Array.from(
					rightColumn.querySelectorAll(
						":scope > .help-content__tab__content"
					)
				)
			: [];

		if (!tabs.length) return;

		let currentIndex = -1;
		const activateTab = (activeIndex) => {
			if (activeIndex === currentIndex) return;

			currentIndex = activeIndex;

			tabs.forEach((tab, index) => {
				const isActive = index === activeIndex;
				const header = tab.querySelector(".help-content__tab__header");
				const description = tab.querySelector(".help-content__tab__desc");

				tab.classList.toggle("is-active", isActive);
				description?.classList.toggle("is-active", isActive);

				if (isActive && description) {
					description.style.setProperty(
						"--help-tab-desc-height",
						`${description.scrollHeight}px`
					);
				}

				header?.setAttribute("aria-expanded", String(isActive));
			});

			contents.forEach((content, index) => {
				content.classList.toggle("is-active", index === activeIndex);
			});
		};

		let resizeFrame;
		const updateActiveDescriptionHeight = () => {
			window.cancelAnimationFrame(resizeFrame);
			resizeFrame = window.requestAnimationFrame(() => {
				const activeDescription = tabsContainer.querySelector(
					".help-content__tab__desc.is-active"
				);

				if (!activeDescription) return;

				activeDescription.style.setProperty(
					"--help-tab-desc-height",
					`${activeDescription.scrollHeight}px`
				);
			});
		};

		window.addEventListener("resize", updateActiveDescriptionHeight);

		const pageScrollContainer = document.querySelector(".wp-site-blocks");
		const leftColumn = section.querySelector(".help-content__left");
		const getHeaderHeight = () =>
			document.querySelector("#header")?.offsetHeight || 0;
		const getTabsAlignmentTop = () => {
			if (window.innerWidth < 782) return getHeaderHeight() + 50;

			if (!leftColumn) return getHeaderHeight() + 16;

			const styles = getComputedStyle(leftColumn);
			const stickyTop = parseFloat(styles.top);
			const paddingTop = parseFloat(styles.paddingTop) || 0;

			return (
				(Number.isFinite(stickyTop)
					? stickyTop
					: getHeaderHeight() + 16) + paddingTop
			);
		};
		const scrollToContent = (index) => {
			const content = contents[index];

			if (!content) return;

			const targetTop =
				content.getBoundingClientRect().top + window.scrollY - getTabsAlignmentTop();

			window.scrollTo({
				top: Math.max(0, targetTop),
				behavior: "smooth",
			});
		};
		const backToActiveTab = document.querySelector(
			'.post-back-to-top[href="#active-tab"]'
		);
		const updateBackToTopVisibility = () => {
			if (!backToActiveTab) return;

			backToActiveTab.classList.toggle(
				"is-visible",
				window.innerWidth < 782 && section.getBoundingClientRect().top < 0
			);
		};

		backToActiveTab?.addEventListener("click", (event) => {
			event.preventDefault();
			event.stopPropagation();

			const activeTab =
				tabsContainer.querySelector(":scope > .help-content__tab.is-active") ||
				tabs[0];

			if (!activeTab) return;

			activateTab(tabs.indexOf(activeTab));

			const targetTop =
				activeTab.getBoundingClientRect().top + window.scrollY - getTabsAlignmentTop();

			window.scrollTo({
				top: Math.max(0, targetTop),
				behavior: "smooth",
			});
		});

		tabs.forEach((tab, index) => {
			const header = tab.querySelector(".help-content__tab__header");

			if (!header) return;

			header.setAttribute("role", "button");
			header.setAttribute("tabindex", "0");

			header.addEventListener("click", () => {
				activateTab(index);
				scrollToContent(index);
			});
			header.addEventListener("keydown", (event) => {
				if (event.key !== "Enter" && event.key !== " ") return;

				event.preventDefault();
				activateTab(index);
				scrollToContent(index);
			});
		});

		const activeTabIndex = tabs.findIndex(
			(tab) =>
				tab.classList.contains("is-active") ||
				tab
					.querySelector(".help-content__tab__desc")
					?.classList.contains("is-active")
		);
		const activeContentIndex = contents.findIndex((content) =>
			content.classList.contains("is-active")
		);
		const initialIndex =
			activeTabIndex >= 0
				? activeTabIndex
				: activeContentIndex >= 0
					? activeContentIndex
					: 0;

		const closeMobileTabs = () => {
			if (window.innerWidth >= 782) return;

			currentIndex = -1;

			tabs.forEach((tab) => {
				tab.classList.remove("is-active");
				tab.querySelector(".help-content__tab__desc")?.classList.remove("is-active");
				tab.querySelector(".help-content__tab__header")?.setAttribute("aria-expanded", "false");
			});
			contents.forEach((content) => content.classList.remove("is-active"));
		};

		activateTab(initialIndex);
		closeMobileTabs();

		let scrollFrame;
		const syncTabWithScroll = () => {
			if (
				window.innerWidth < 782 ||
				!contents.length
			) {
				return;
			}

			window.cancelAnimationFrame(scrollFrame);
			scrollFrame = window.requestAnimationFrame(() => {
				const activationLine = getTabsAlignmentTop() + 8;
				let visibleIndex = 0;

				contents.forEach((content, index) => {
					if (content.getBoundingClientRect().top <= activationLine) {
						visibleIndex = index;
					}
				});

				activateTab(Math.min(visibleIndex, tabs.length - 1));
			});
		};

		window.addEventListener("scroll", syncTabWithScroll, { passive: true });
		pageScrollContainer?.addEventListener("scroll", syncTabWithScroll, {
			passive: true,
		});
		window.addEventListener("resize", syncTabWithScroll);
		window.addEventListener("resize", closeMobileTabs);
		window.addEventListener("scroll", updateBackToTopVisibility, {
			passive: true,
		});
		pageScrollContainer?.addEventListener("scroll", updateBackToTopVisibility, {
			passive: true,
		});
		syncTabWithScroll();
		updateBackToTopVisibility();
	});
}
